/**
 * @author Gananath Athukorala
 * @version 0.1
 */

import React from "react";
import labelsEN from "../../../locales/en/translation.json";
import { Box } from "@mui/material";
import { Tabs, Tab } from "react-bootstrap";
import SystemSettings from "./components/SystemSettings";
import TokenSettings from "./components/TokenSettings";
import ClientSettings from "./components/ClientSettings";
import DeploymentSettings from "./components/DeploymentSettings";
import MasterDataSettings from "./components/masterDataSettings/MasterDataSettings"

const AdvancedSettings = () => {
  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <h1>{labelsEN.app_advancedsettings_page_title}</h1>
        <br />
        <br />
        <Tabs
          defaultActiveKey="SystemSettings"
          id="uncontrolled-tab-example"
          className="mb-3"
          justify
        >
          <Tab eventKey="SystemSettings" title={"System Settings"}>
            <SystemSettings />
          </Tab>
          <Tab eventKey="TokenManagement" title={"Token Management"}>
            <TokenSettings />
          </Tab>
          <Tab eventKey="ClientSettings" title={"Client Settings"}>
            <ClientSettings />
          </Tab>
          <Tab eventKey="DeploymentSettings" title={"Deployment Settings"}>
            <DeploymentSettings />
          </Tab>
          <Tab eventKey="MasterData" title={"Master Data"}>
            <MasterDataSettings />
          </Tab>
        </Tabs>
      </Box>
    </div>
  )
};

export default AdvancedSettings;
